import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('home.categories.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home.categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-100/60 transition-all duration-300 cursor-pointer border border-transparent hover:border-primary-200/60"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-200 group-hover:text-primary-700 transition-all duration-300 mb-3">
                <i className={`${category.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap mb-1">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-500 hidden md:block">
                {category.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}